// NATIVE 
import React, { useEffect } from 'react';


// CUSTOM 
import { Avatar, Skeleton } from '@mui/material';
import { useDispatch } from 'react-redux';



// INSTALLED 
import { getImageStore } from '../store/files';



interface AvatarTablesProps {
  urlImage: string;
  typeImage: string;
  style?: React.CSSProperties; // 🔹 para poder pasar estilos desde fuera
}

export const AvatarTables = ({ urlImage, typeImage, style }: AvatarTablesProps) => {


     // DISPATCH 
     const dispatch = useDispatch();


    // USE STATES
    const [logoUrl, setLogoUrl] = React.useState('');



    const getLogoImage = async(imageName:string) => { 
    

          const response =  await dispatch( getImageStore(imageName, typeImage) );


           if ( response instanceof Blob) {
              const imageUrl = URL.createObjectURL(response);
              setLogoUrl(imageUrl);
           }

    }


    useEffect(() => {
        getLogoImage(urlImage);
    }, [urlImage]);
    

  return (
    <>
       {
        logoUrl 
        ?
        <Avatar
            sx={{ width: 90, height: 90 }}
            slotProps={{ img: {
              style: {
                objectFit: 'fill' // También: 'cover', 'contain', 'none', 'scale-down'
              }
            } }}
            sizes={'100'}
            alt="Logo Compañia"  
            src={ logoUrl }
            variant='square'
            style={style}
        >
            Q
        </Avatar>

        : <Skeleton animation="wave" variant="rectangular"  width={90} height={90} />
       }
       
    </>
  )
}





// // NATIVE 
// import React, { useEffect } from 'react';

// // CUSTOM 
// import { Avatar, Skeleton } from '@mui/material';
// import { useDispatch } from 'react-redux';

// // INSTALLED 
// import { getImageStore } from '../store/files';

// interface AvatarTablesProps {
//   urlImage: string;
//   typeImage: string;
//   style?: React.CSSProperties; // 🔹 para poder pasar estilos desde fuera
// }

// export const AvatarTables = ({ urlImage, typeImage, style }: AvatarTablesProps) => {
//   const dispatch = useDispatch();

//   // USE STATES
//   const [logoUrl, setLogoUrl] = React.useState('');

//   const getLogoImage = async (imageName: string) => {
//     const response = await dispatch(getImageStore(imageName, typeImage));

//     if (response instanceof Blob) {
//       const imageUrl = URL.createObjectURL(response);
//       setLogoUrl(imageUrl);
//     }
//   };

//   useEffect(() => {
//     getLogoImage(urlImage);
//   }, [urlImage]);

//   return (
//     <>
//       {logoUrl ? (
//         <Avatar
//           sx={{ width: 90, height: 90 }}
//           slotProps={{
//             img: {
//               style: {
//                 objectFit: 'cover', // 🔹 mejor para fotos de perfil
//               },
//             },
//           }}
//           sizes={'100'}
//           alt="Logo Compañia"
//           src={logoUrl}
//           variant="circular"
//           style={style} // 🔹 aplica estilos externos
//         >
//           Q
//         </Avatar>
//       ) : (
//         <Skeleton animation="wave" variant="circular" width={90} height={90} />
//       )}
//     </>
//   );
// };
